import React from 'react'
import { connect } from 'react-redux'
import { Modal, Form, Table, Button} from 'antd'
import { history } from '../../../../../index'
import CommonService from '../../../../../services/commonService'
import urlConstant from '../../../../../constants/urlConstant'
import dataConstant from '../../../../../constants/dataConstants'
import Config from '../../../../../config/config'

@connect(({ user }) => ({ user }))
@Form.create()
class SwitchAccount extends React.Component {
  constructor(props) {
    super(props)
    this.CommonService = new CommonService()
    this.user = props.user;
    this.state = {
      visibleSwitchAccount: props.visible,
      UserAppAccessRightsByTenantData: []      
    }
  }

  componentDidUpdate(prevProps) {
    const {visible} = this.props;
    
    if (visible !== prevProps.visible) {
      this.setModalVisible(visible);
    }

    if(visible)
      this.getUserAppAccessRightsByTenant();
  }

  setModalVisible(visible){
    this.setState({ visibleSwitchAccount: visible });
  }
 
  impersonateUser = (Email, RefId, RefType) => {
    const { user: { id } } = this.props
    const { IdentityClientID } = Config
    const model = {
      FromUserId: id,
      ToUserName: Email,
      EntiryRefId: RefId,
      EntiryRefType: RefType,
      ImpersonatorClientId: IdentityClientID
    }
    this.setCustomSpinner()
    this.CommonService.httpPost(urlConstant.Impersonate.GenerateImpersonateLoginGUID, model, true)
      .then(response => {
        if (response.status === 'Success') {
          localStorage.clear()
          window.location.href = `${urlConstant.Impersonate.UserImpersonate}?q=${response.impersonateLoginGUID}`
        }
      }).catch(err => {
        this.removeCustomSpinner()
        console.log(err)
      }).finally(() => {
        this.removeCustomSpinner()
      })
  }

  setCustomSpinner = () => {
    const { dispatch } = this.props
    dispatch({
      type: dataConstant.CustomSpinner.Setloader,
    })
  }
  
  removeCustomSpinner = () => {
    const { dispatch } = this.props
    dispatch({
      type: dataConstant.CustomSpinner.RemoveLoader,
    })
  }

  switchAccountOpenPopup = () => {
    
  }

  handleSubmitSwitchAccount = record => {
    const userData = JSON.parse(localStorage.getItem('webappuser'));  
    if(record.RoleName === dataConstant.RoleType.Client)
    {
    this.impersonateUser(userData.email,record.EntityRefId,record.EntityRefType)
    }
    else{
    let urci = ''
    let urce = ''
    let urcd = ''
    let urva = ''    
    const { dispatch } = this.props         
    const ApiUrl= `${urlConstant.RoleRights.GetUserAccessRights}?UserAppAccessRightsID=${record.UserAppAccessRightsID}`      
    this.CommonService.httpGet(ApiUrl, true)
        .then((response) => {          
          if (response.Value) {                        
            urci = this.CommonService.EncryptData(response.Value.Data.CanAdd);
            urce = this.CommonService.EncryptData(response.Value.Data.CanEdit);
            urcd = this.CommonService.EncryptData(response.Value.Data.CanDelete);
            urva = this.CommonService.EncryptData(response.Value.Data.ViewAudited);            
            if(userData){
              userData.RefId = record.EntityRefId.toString();
              userData.RefType = record.EntityRefType ==='Factory' ? dataConstant.RoleType.FactoryAdmin : record.EntityRefType;
              userData.role = record.RoleName;            
              userData.URCI = urci;
              userData.URCE = urce;
              userData.URCD = urcd;
              userData.URVA = urva;              
              userData.isAdmin=userData.role === dataConstant.RoleType.Admin
              
              localStorage.setItem('webappuser', JSON.stringify(userData));    
              if(userData.role === dataConstant.RoleType.Supplier)
              {
               this.GetUserReferenceDetail(userData.RefId)
              }
              setTimeout(() => {
              dispatch({
                type: 'user/LOAD_CURRENT_ACCOUNT',
                payload: ""
              })     
              this.CommonService.SetMenuList(userData.role, () => {
                dispatch({
                  type: 'menu/GET_DATA',
                  payload: ""
                })
                this.handleCancelSwitchAccount();
                history.push('/dashboard/alpha');
                window.location.reload();              
              })  
            },300)     
            } 
          }
        }).catch(err => {
          console.log(err);
        })    
    }
  }

  GetUserReferenceDetail = (RefId) => {
    const { dispatch } = this.props;     
    if(RefId){
      const URL =  `${urlConstant.Common.GetUserReferenceDetail}?RefId=${RefId}`
      this.CommonService.httpGet(URL, true)
      .then(response => {
        if (response) {
            if (response.Value && response.Value.Data) {
              const userData = JSON.parse(localStorage.getItem('webappuser'));
              if(userData){
                userData.MaterialType = response.Value.Data.ProductCategroy;
                localStorage.setItem('webappuser', JSON.stringify(userData));

                dispatch({
                  type: 'user/LOAD_CURRENT_ACCOUNT',
                  payload: ""
                })
              }                                   
            }
        }
      },err => {
          console.log(err);
      }).catch(err => {
          console.log(err);
      })
      .finally(() => {
             
        dispatch({
          type: 'menu/GET_DATA',
          payload: ""
        })
      });
    }
  }

  handleCancelSwitchAccount = () => {
    const {switchAccountVisibilityChange} = this.props;
    if(switchAccountVisibilityChange){
      switchAccountVisibilityChange(false);
    }
    this.setState({
      visibleSwitchAccount: false
    })
  }

  getUserAppAccessRightsByTenant = () => {
      const appAccessModel={
        TenantGuid:this.user.TenantGuid,
        UserId: this.user.id,
        IdentityClientId: this.user.IdentityClientID
      }
      this.CommonService.httpPost(urlConstant.UserSwitchAccount.GetUserAppAccessRightsByTenant, appAccessModel, true)
        .then((response) => {
          if (response.Value && response.Value.List) {
            this.setState({ UserAppAccessRightsByTenantData: response.Value.List || [] })
          }
        }).catch(err => {
          console.log(err);
        })
  }

  render() {
    const userData = JSON.parse(localStorage.getItem('webappuser'));
    const { UserAppAccessRightsByTenantData, visibleSwitchAccount }=this.state
    const columns = [
      {
        title: 'Role',
        dataIndex: 'RoleName',
        key: 'RoleName',
        width:150
      },
      {
        title: 'Company',
        dataIndex: 'CompanyName',
        key: 'CompanyName',
        ellipsis:true,
        width:300
      },
      {
        title: 'Action',
        key: 'action',
        width:100,
        render: (text, record) => (
          <Button 
            className="mr-1" 
            size="small" 
            type="primary"
            disabled={record.EntityRefId.toString() === userData.RefId && (record.EntityRefType === userData.RefType || record.EntityRefType === "Factory")
                  &&  record.RoleName ===  userData.role}
            onClick={() => { this.handleSubmitSwitchAccount(record)}}
          >
            <i className="fa fa-switch" />{record.RoleName === dataConstant.RoleType.Client ? 'Impersonate' : 'Switch' }
          </Button>
        ),
      },
    ];

    return (
      <div>
        <Modal
          title="Switch Account"
          visible={visibleSwitchAccount}
          maskClosable={false}
          width="700px"
          onCancel={this.handleCancelSwitchAccount}
          footer={
            <Button type="primary" onClick={() => {this.handleCancelSwitchAccount()}}>Ok</Button>
          }
        >
          <div className="col-md-12 cm-popup-v-scroll">
            <Form onSubmit={this.onSubmitChangePassword}>
              <div className="row">
                <div className="col-xl-12">
                  <Table 
                    dataSource={UserAppAccessRightsByTenantData} 
                    columns={columns} 
                    pagination={false}
                  />
                </div>
              </div>
            </Form>
          </div>
        </Modal>
      </div>
    )
  }
}

export default SwitchAccount
